import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from 'src/app/hooks';
import { removeFile } from 'src/features/globalSlice';
import { GlobalFile } from 'src/store/models/Action';

export const useFileSelector = (file: GlobalFile): GlobalFile[] => {
  const dispatch = useAppDispatch();

  const files = useAppSelector((state) => state.global.files);

  useEffect(() => {
    return () => {
      dispatch(removeFile(file));
    };
    // eslint-disable-next-line
  }, []);

  return files
    ?.slice()
    ?.reverse()
    ?.filter((f) => f.id === file.id && (file.url ? file.url === f.url : true));
};
